import React from 'react';
import { useSelector } from 'react-redux';
import services from 'services';
import selectors from 'state/selectors';
import utils from 'utils';
import CommonButton from 'components/Buttons/CommonButton';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const CheckDuplicateDocument = () => {
  const t = utils.intl.useTranslator();
  const protocol = useSelector(selectors.documents.selectActiveDocumentID);
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const { checkDocuments } = useCheckBeforeAction(actionType.CHECK_DUPLICATE_DOCUMENT);
  const onConfirm = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    try {
      if (!protocol) return;
      await services.checkDuplicateDocument(protocol);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <CommonButton
        id="duplicate-document-btn"
        value={t('duplicate-document')}
        action={onConfirm}
        scope="tertiary"
        disabled={!utils.user.isActionEnabled(records, actionType.CHECK_DUPLICATE_DOCUMENT)}
        customIcon="copy"
      />
    </>
  );
};

export default CheckDuplicateDocument;
